import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Gas Volume Calculator - Learn How to Calculate Gas Volume Easily';
const DESCRIPTION = 'This calculator easily calculates gas volume and explains the necessary steps to calculate it.';
const KEYWORDS = 'Gas volume calculation, Gas volume calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/gasvolume';
function Calculator() {
    const [mass, setMass] = useState('');
    const [density, setDensity] = useState('');
    const [volume, setVolume] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!mass || !density) {
            setError('Please enter mass and density correctly');
            setVolume('');
            setExplanation('');
            return;
        }
        const massValue = parseFloat(mass);
        const densityValue = parseFloat(density);
        if (isNaN(massValue) || isNaN(densityValue)) {
            setError('Please enter valid values for mass and density');
            setVolume('');
            setExplanation('');
            return;
        }
        const gasVolume = massValue / densityValue;
        setVolume(gasVolume.toFixed(2));
        setExplanation(
            `Gas Volume (liters) = Mass (grams) / Density = ${massValue} grams / ${densityValue} g/cm³ = ${gasVolume.toFixed(2)} liters`
        );
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            Gas volume can be calculated using the ideal gas law, which is known as Boyle-Mariotte's law or the ideal gas law. This law describes the behavior of gases under certain conditions and is expressed as the following mathematical equation:
                                            PV = nRT
                                            Where:
                                            <ul>
                                                <li>
                                                    P stands for pressure (Pressure) in pascals (Pa) or other pressure units.
                                                </li>
                                                <li>
                                                    V stands for volume in cubic meters (m³) or liters (L), and it must be consistent with the unit of pressure.
                                                </li>
                                                <li>
                                                    n represents the number of moles (Number of moles) of gas.
                                                </li>
                                                <li>
                                                    R is the gas constant (Gas Constant) in joules per mole-kelvin (J/(mol·K)).
                                                </li>
                                                <li>
                                                    T is temperature (Temperature) in kelvin (K), and it must be consistent with the unit of the gas constant.
                                                </li>
                                            </ul>
                                            To calculate the gas volume, we can rearrange the equation as follows: <br />
                                            V = (nRT) / P <br />
                                            When you have the following values: <br />
                                            <ul>
                                                <li>
                                                    n: Number of moles of gas.
                                                </li>
                                                <li>
                                                    R: Gas constant (depends on the measurement units used).
                                                </li>
                                                <li>
                                                    T: Required temperature in kelvin (Kelvin).
                                                </li>
                                                <li>
                                                    P: Pressure in pascals (Pa).
                                                </li>
                                                <li>
                                                    Enter these values into the equation, and you will get the gas volume in the appropriate unit (cubic meters or liters). Make sure to unify the units correctly.
                                                </li>
                                            </ul>
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                                                                <div dir=";tr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Mass (grams)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="80"
                                                        value={mass}
                                                        onChange={(e) => setMass(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Density (g/cm³)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="8"
                                                        value={density}
                                                        onChange={(e) => setDensity(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Gas Volume
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {volume !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Gas Volume (liters): {volume} liters
                                                                </p>
                                                                {explanation !== '' && (
                                                                    <p className='p-3 mb-2 bg-info text-black'>
                                                                        Calculation Steps: <br />{explanation}
                                                                    </p>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
